module.exports = __webpack_public_path__ + "media/slider/Subscription-5-IND-4f52d3a4.jpg";